export function transformSettingsKey(
  originalKey: string,
  { isMobile }: { isMobile: boolean },
): string {
  // mobileKey could be absent in saved settings before, e.g groupCardListWidgetSpacing
  if (!originalKey) {
    return originalKey;
  }
  const keyWithUpperFirst = originalKey[0].toUpperCase() + originalKey.slice(1);
  return isMobile ? `mobile${keyWithUpperFirst}` : originalKey;
}

export function doNotTransformSettingsKey(originalKey: string): string {
  return originalKey;
}
